// constants
import { AuthActionTypes } from './constants';

export type AuthActionType = {
    type:
        | AuthActionTypes.API_RESPONSE_SUCCESS
        | AuthActionTypes.API_RESPONSE_ERROR
        | AuthActionTypes.FORGOT_PASSWORD
        | AuthActionTypes.FORGOT_PASSWORD_CHANGE
        | AuthActionTypes.LOGIN_USER
        | AuthActionTypes.LOGOUT_USER
        | AuthActionTypes.RESET
        | AuthActionTypes.UPDATEDRECORDARRAY
        | AuthActionTypes.PAGENUMBER;
    payload: {} | string;
};

type UserData = {
    id: number;
    email: string;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    role: string;
    franchiseId?: string;
    token: string;
};

type PageData = {
    current: number;
    previous: number;
};
type RecordData = {
    ids: string[];
    status: string;
};
// common success
export const authApiResponseSuccess = (actionType: string, data: UserData | {}): AuthActionType => ({
    type: AuthActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const authApiResponseError = (actionType: string, error: string): AuthActionType => ({
    type: AuthActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const loginUser = (email: string, password: string): AuthActionType => ({
    type: AuthActionTypes.LOGIN_USER,
    payload: { email, password },
});

export const logoutUser = (): AuthActionType => ({
    type: AuthActionTypes.LOGOUT_USER,
    payload: {},
});

export const forgotPassword = (email: string): AuthActionType => ({
    type: AuthActionTypes.FORGOT_PASSWORD,
    payload: { email },
});

export const resetPassword = (data: { email: string; token: string; password: string }): AuthActionType => ({
    type: AuthActionTypes.FORGOT_PASSWORD_CHANGE,
    payload: data,
});

export const resetAuth = (): AuthActionType => ({
    type: AuthActionTypes.RESET,
    payload: {},
});

export const pageNumber = (data: PageData | {}): AuthActionType => ({
    type: AuthActionTypes.PAGENUMBER,
    payload: data,
});

export const updatedRecordArray = (data: RecordData): AuthActionType => ({
    type: AuthActionTypes.UPDATEDRECORDARRAY,
    payload: data,
});
